import React, { useEffect, useRef, useState } from 'react'
import { CFormLabel as CLabel, CFormInput as CInput, CFormSelect as CSelect, CModal, CModalBody, CModalFooter, CButton } from '@coreui/react'
import { DateTimePickerComponent } from '@syncfusion/ej2-react-calendars'
import PatientInsuranceFn from '../../services/general/PatientInsuranceAPI.api.js'
import Select from 'react-select'
import MenuList from '../../components/shared/ReactSelectWrapper'
import fetchPatientData from '../../services/general/patientGeneralAPI.api.js'
import PatientInsurance from './PatientInsurance.jsx'
const AddAppointments = ({ allDayData, props, locations, testoptions, patientData, allData, dataForEdit, appointments }) => {
  const [currentTab, setCurrentTab] = useState('general')
  const [providerList, setProviderList] = useState([])
  const [selectedProvider, setSelectedProvider] = useState(null)
  const [filteredFacilities, setFilteredFacilities] = useState([])
  const [selectedFacility, setSelectedFacility] = useState(null)
  const [filteredPatients, setFilteredPatients] = useState([])
  const [selectedPatient, setSelectedPatient] = useState(null)
  const [activeTab, setActiveTab] = useState('basic')
  const [roomNumber, setRoomNumber] = useState('')
  const [questionTab, setQuestionTab] = useState(false)
  const newPatient = useRef({})
  const [newEvent, setNewEvent] = useState(true)
  const [modalVisible, setModalVisible] = useState(false)
  const [priorAuthVisible, setPriorAuthVisible] = useState(false)
  const [priorAuthDetails, setPriorAuthDetails] = useState({
    priorAuthNo: '',
    expDate: '',
    noOfTimes: '',
  })

  const [isCoSignRequired, setIsCoSignRequired] = useState(false)
  const [isPatientInFacility, setIsPatientInFacility] = useState(false)
  const [errors, setErrors] = useState({
    provider: '',
    facility: '',
    patient: '',
  })

  const [insurance, setInsurance] = useState(null)
  const [insuranceList, setInsuranceList] = useState([])
  const [insuranceTypes, setInsuranceTypes] = useState([])
  const [selectedInsuranceDetails, setSelectedInsuranceDetails] = useState({})
  const [addedInsurances, setAddedInsurances] = useState([])
  const [isFacility, setIsFacility] = useState(false)

  const [otherDetails, setOtherDetails] = useState({
    priorAuth: {
      isRequired: false,
      details: {
        priorAuthNo: '',
        expDate: '',
        noOfTimes: '',
      },
    },
    isCoSignRequired: false,
    isPatientInFacility: false,
  })

  const fetchOriginalInsurance = async (patientId) => {
    let patientInsurance = await PatientInsuranceFn('SELECT', '', patientId)
    let Insurance = {}
    try {
      patientInsurance = JSON.parse(patientInsurance.d)?.Data
      if (patientInsurance.length > 0) {
        Insurance = JSON.parse(patientInsurance[0].InsuranceDetails)
        Insurance = Insurance[0] || {}
      }
      return Insurance
    } catch (e) {}
  }

  useEffect(() => {
    const initializeData = async () => {
      if (dataForEdit.length > 0) {
        const facility = dataForEdit[0]?.current?.Facility ?? []
        const provider = dataForEdit[0]?.current?.Provider ?? []
        const patient = dataForEdit[0]?.current?.Patient ?? []
        const isInFacility = dataForEdit[0]?.data?.isInFacility || false
        const otherDetails = dataForEdit[0]?.data?.otherDetails ?? {
          priorAuth: {
            isRequired: false,
            details: {
              priorAuthNo: '',
              expDate: '',
              noOfTimes: '',
            },
          },
          isCoSignRequired: false,
          isPatientInFacility: false,
        }

        if (otherDetails) {
          setOtherDetails(otherDetails)
        }
        setSelectedFacility(facility)
        setSelectedProvider(provider)
        setSelectedPatient(patient)
        setIsFacility(isInFacility)

        try {
          const insurance = await fetchOriginalInsurance(dataForEdit[0]?.data?.PatientID)
          setAddedInsurances(insurance)
        } catch (error) {
          console.error('Error fetching insurance:', error)
          setAddedInsurances([])
        }
      }
    }

    initializeData()
  }, [dataForEdit])

  const selectPatientFn = async (e) => {
    setSelectedPatient(e)
    allData.current.Patient = e
    let selectedPatient = e
    let patient = {}
    let insurances = []
    let isAuth = false
    if (selectedPatient) {
      patient = patientData.find((p) => p.PatientID === selectedPatient.value)
      let patientInsurance = await PatientInsuranceFn('SELECT', '', selectedPatient.value)
      try {
        patientInsurance = JSON.parse(patientInsurance.d)?.Data
      } catch (e) {}

      setSelectedInsuranceDetails({ Insurances: patientInsurance })
      setRoomNumber(patient ? patient.Room : '')
      insurances = patient.Insurance
    } else {
      setRoomNumber('')
    }

    let validIDs = [6, 7, 8, 12, 13]
    try {
      insurances.find((ins) => {
        if (ins.InsuranceID === 6 || ins.InsuranceID === 7 || ins.InsuranceID === 8 || ins.InsuranceID === 12 || ins.InsuranceID === 13) {
          isAuth = true
          return true // Return true to stop the search early once a match is found
        }
        return false
      })
      // setModalVisible(true); // Set modal visible state to true
    } catch (e) {
      console.error('Error occurred while checking insurance IDs:', e)
    }

    let patientInsurance = localStorage.getItem('PatientInsurance')
  }

  const selectProviderFn = (e) => {
    setSelectedProvider(e)
    allData.current.Provider = e
    if (e) {
      const provider = allDayData.find((p) => p.ID === e.value)
      setFilteredFacilities(provider ? provider.Facilities : [])
    } else {
      setFilteredFacilities([])
    }
  }

  const selectFacilityFn = (e) => {
    setSelectedFacility(e)
    allData.current.Facility = e
    let selectedFacility = e
    if (selectedFacility) {
      let patients = patientData.filter((p) => p.FacilityName === selectedFacility.label)
      let filterAppointments = appointments.filter((item) => item.data.Status === 'Scheduled' || item.data.Status === 'Rescheduled')
      let ScheduledPatient = filterAppointments.map((item) => item.data.PatientID)
      let notSchedule = patients?.filter((item) => !ScheduledPatient.includes(item?.PatientID))
      // if (appointments.length > 0){
      //   appointments.map((item) => {
      //     patients.filter((patient) => {
      //       if (patient.PatientID === item?.current?.Patient?.value) {
      //         patients = patients.filter((p) => p.PatientID !== item?.current?.Patient?.value);
      //       }
      //     });
      //   });
      // }
      setFilteredPatients(notSchedule.map((p) => ({ value: p.PatientID, label: `${p.FirstName} ${p.LastName}` })))
    } else {
      setFilteredPatients([])
    }
  }

  const AddPatients = () => {
    setNewEvent(true)
    if (Object.keys(props).length !== 0 && props.PatientID) {
      newPatient.current = { value: props.PatientID, label: props.Subject }
    } else {
      newPatient.current = { value: '', label: '' }
      setNewEvent(false)
    }
  }

  const validateForm = () => {
    let hasError = false
    const newErrors = { provider: '', facility: '', patient: '' }

    if (!selectedProvider) {
      newErrors.provider = 'Please select a provider.'
      hasError = true
    }

    if (!selectedFacility) {
      newErrors.facility = 'Please select a facility.'
      hasError = true
    }

    if (!selectedPatient) {
      newErrors.patient = 'Please select a patient.'
      hasError = true
    }

    setErrors(newErrors)
    return !hasError
  }

  // const handlePriorAuthDetailsChange = (e) => {
  //   const { name, value } = e.target;
  //   setPriorAuthDetails((prevDetails) => ({
  //     ...prevDetails,
  //     [name]: value,
  //   }));
  // };

  const getData = async () => {
    let insuranceData = await fetchPatientData('GET', 'Insurance', '{}')
    insuranceData = JSON.parse(insuranceData.d)?.Data
    const uniqueInsuranceTypes = Array.from(new Set(insuranceData.map((ins) => ins.Type)))
    setInsuranceList(insuranceData)
    setInsuranceTypes(uniqueInsuranceTypes)
  }

  const handlePriorAuthCheckboxChange = (e) => {
    setOtherDetails((prev) => ({
      ...prev,
      priorAuth: {
        ...prev.priorAuth,
        isRequired: e.target.checked,
      },
    }))
  }

  const handlePriorAuthDetailsChange = (e) => {
    const { name, value } = e.target
    setOtherDetails((prev) => ({
      ...prev,
      priorAuth: {
        ...prev.priorAuth,
        details: {
          ...prev.priorAuth.details,
          [name]: value,
        },
      },
    }))
  }

  const handleCoSignRequiredChange = (e) => {
    setOtherDetails((prev) => ({
      ...prev,
      isCoSignRequired: e.target.checked,
    }))
  }

  const handlePatientFacilityChange = (e) => {
    // setOtherDetails((prev) => ({
    //   ...prev,
    //   isPatientInFacility: e.target.checked,
    // }));
    setIsFacility(e.target.checked)
    allData.current.isInFacility = e.target.checked
  }

  useEffect(() => {
    getData()
  }, [])
  useEffect(() => {
    setProviderList(
      allDayData
        .filter((obj) => obj.Status !== 'Deactive' && obj.status !== 'Deactive')
        .map((obj) => {
          return { value: obj.ID, label: obj.Name }
        }),
    )
  }, [allDayData])

  useEffect(() => {
    allData.current.otherDetails = otherDetails
  }, [otherDetails])

  useEffect(() => {
    allData.current.isInFacility = isFacility
  }, [isFacility])

  // allData.current.isInFacility = isFacility
  return props !== undefined && Object.keys(props).length !== 0 ? (
    <>
      <div className=" " style={{ height: '400px', overflow: 'auto' }}>
        {modalVisible && (
          <CModal visible={modalVisible} onClose={() => setModalVisible(false)}>
            <CModalBody>
              <div>
                <CLabel htmlFor="authorizationNumber">Prior Authorization Number:</CLabel>
                <CInput type="text" id="authorizationNumber" placeholder="Enter authorization number" />
              </div>
              <div>
                <CLabel htmlFor="numberOfVisits">Number of Visits:</CLabel>
                <CInput type="number" id="numberOfVisits" placeholder="Enter number of visits" />
              </div>
              <div>
                <CLabel htmlFor="expirationDate">Expiration Date:</CLabel>
                <CInput type="date" id="expirationDate" placeholder="Select expiration date" />
              </div>
            </CModalBody>
            <CModalFooter>
              <CButton
                onClick={() => {
                  setModalVisible(false)
                }}
              >
                Submit
              </CButton>
            </CModalFooter>
          </CModal>
        )}
        {
          <table className="custom-event-editor" style={{ width: '100%' }} cellPadding={5}>
            <tbody>
              {
                <div>
                  <tr>
                    <td className="e-textlabel">Appointment Name</td>
                    <td colSpan={4}>
                      <input id="AppointmentName" className="e-field e-input" type="text" defaultValue={props?.AppointmentName} name="AppointmentName" style={{ width: '100%' }} />
                    </td>
                  </tr>
                  <tr>
                    <td className="e-textlabel">Provider</td>
                    <td colSpan={4}>
                      <Select id="providerSelect" value={selectedProvider} onChange={selectProviderFn} options={providerList} placeholder="Select Provider" name="Provider" required />
                    </td>
                  </tr>
                  <tr>
                    <td className="e-textlabel">Facilities</td>
                    <td colSpan={4}>
                      <Select id="facilitySelect" value={selectedFacility} onChange={selectFacilityFn} options={filteredFacilities.map((obj) => ({ value: obj.ID, label: obj.Name }))} placeholder="Select Facility" name="Facility" />
                    </td>
                  </tr>
                  <tr>
                    <td className="e-textlabel">Select Patient</td>
                    <td colSpan={4}>
                      <Select id="Patient" value={selectedPatient} onChange={selectPatientFn} components={{ MenuList }} options={filteredPatients} name="Patient" placeholder="Type Name of Patient" />
                    </td>
                  </tr>
                  <tr>
                    <td className="e-textlabel">Room Number</td>
                    <td colSpan={4}>
                      <input id="RoomNumber" className="e-field e-input" type="text" value={roomNumber} name="RoomNumber" readOnly style={{ width: '100%' }} />
                    </td>
                  </tr>
                  <tr>
                    <td className="e-textlabel">Visit Reason</td>
                    <td colSpan={4}>
                      <input id="VisitReason" className="e-field e-input" type="text" defaultValue={'N/P (New Patient)'} name="VisitReason" style={{ width: '100%' }} />
                    </td>
                  </tr>
                  <tr>
                    <td className="e-textlabel">Remarks</td>
                    <td colSpan={4}>
                      <textarea id="Notes" defaultValue={props?.Notes} className="e-field e-input" name="Notes" rows={1} cols={50} style={{ width: '100%', height: '60px !important', resize: 'vertical' }} />
                    </td>
                  </tr>
                  {/* <tr className='d-flex justify-content-end ' >
                  <td className="e-textlabel" >
                    <CButton className='px-3 py-0 ' onClick={(e) => setActiveTab('Insurance')}>
                      Next
                    </CButton>
                  </td>
                </tr> */}

                  <tr style={{ display: 'none' }}>
                    <td className="e-textlabel">From</td>
                    <td colSpan={4}>
                      <DateTimePickerComponent id="StartTime" format="dd/MM/yy hh:mm a" data-name="StartTime" value={new Date(props?.startTime || props?.StartTime)} className="e-field" />
                    </td>
                  </tr>
                  <tr style={{ display: 'none' }}>
                    <td className="e-textlabel">To</td>
                    <td colSpan={4}>
                      <DateTimePickerComponent id="EndTime" format="dd/MM/yy hh:mm a" data-name="EndTime" value={new Date(props.endTime || props.EndTime)} className="e-field" />
                    </td>
                  </tr>
                </div>
              }
              <div className="mt-3">
                <h5>Insurance</h5>
              </div>
              {
                <div className="w-100">
                  <PatientInsurance
                    allData={allData}
                    Credentialed={'hidden'}
                    addedInsurances={addedInsurances}
                    setAddedInsurances={setAddedInsurances}
                    selectedDetails={selectedInsuranceDetails}
                    insuranceList={insuranceList}
                    insuranceTypes={insuranceTypes}
                    setActiveTab={setActiveTab}
                    props={props}
                    type={'withScheduler'}
                    patientId={props.PatientID || selectedPatient?.value}
                  />
                </div>
              }

              <div className="mt-3">
                <h5>Other Details</h5>
              </div>
              <div className="e-textlabel">
                {/* Prior Auth Checkbox */}
                <div className="form-check mb-3 d-flex align-items-center gap-2">
                  <input type="checkbox" id="priorAuthCheckbox" className="form-check-input" checked={otherDetails?.priorAuth?.isRequired} onChange={handlePriorAuthCheckboxChange} />
                  <label htmlFor="priorAuthCheckbox" className="form-check-label mt-1">
                    Does Need Prior Auth?
                  </label>
                </div>

                {/* Prior Auth Details */}
                {otherDetails?.priorAuth?.isRequired && (
                  <div className="border p-3 mb-3">
                    <div className="mb-2">
                      <label htmlFor="priorAuthNo" className="form-label">
                        Prior Auth No:
                      </label>
                      <input type="text" id="priorAuthNo" name="priorAuthNo" className="form-control" value={otherDetails?.priorAuth?.details?.priorAuthNo} placeholder="Enter Prior Auth No" onChange={handlePriorAuthDetailsChange} />
                    </div>
                    {/* <div className="mb-2">
                      <label htmlFor="expDate" className="form-label">
                        Expiration Date:
                      </label>
                      <input
                        type="date"
                        id="expDate"
                        name="expDate"
                        className="form-control"
                        value={otherDetails?.priorAuth?.details?.expDate}
                        onChange={handlePriorAuthDetailsChange}
                      />
                    </div> */}

                    <div className="mb-2 mt-2">
                      <label htmlFor="expDate" className="form-label">
                        Expiration Date:
                      </label>
                      <DateTimePickerComponent
                        id="expDate"
                        name="expDate"
                        format="MM/dd/yyyy"
                        value={otherDetails?.priorAuth?.details?.expDate ? new Date(otherDetails.priorAuth.details.expDate) : null}
                        className="form-control"
                        change={(e) => {
                          const selectedDate = e?.value
                          setOtherDetails((prev) => ({
                            ...prev,
                            priorAuth: {
                              ...prev.priorAuth,
                              details: {
                                ...prev.priorAuth.details,
                                expDate: selectedDate?.toISOString(),
                              },
                            },
                          }))
                        }}
                      />
                    </div>

                    <div>
                      <label htmlFor="noOfTimes" className="form-label">
                        No. of Times:
                      </label>
                      <input type="number" id="noOfTimes" name="noOfTimes" className="form-control" value={otherDetails?.priorAuth?.details?.noOfTimes} placeholder="Enter No. of Times" onChange={handlePriorAuthDetailsChange} />
                    </div>
                  </div>
                )}

                {/* Co-sign Required Checkbox */}
                <div className="form-check mb-3 mt-1">
                  <input type="checkbox" id="coSignCheckbox" className="form-check-input" checked={otherDetails?.isCoSignRequired} onChange={handleCoSignRequiredChange} />
                  <label htmlFor="coSignCheckbox" className="form-check-label">
                    Co-sign Required.
                  </label>
                </div>

                {/* Patient in Facility Checkbox */}
                <div className="form-check mb-3 mt-1">
                  <input type="checkbox" id="patientFacilityCheckbox" className="form-check-input" checked={isFacility} onChange={handlePatientFacilityChange} />
                  <label htmlFor="patientFacilityCheckbox" className="form-check-label">
                    Patient in Facility.
                  </label>
                </div>
              </div>
            </tbody>
          </table>
        }
      </div>
    </>
  ) : (
    <div></div>
  )
}

export default AddAppointments
